import { render, staticRenderFns } from "./NewNode.vue?vue&type=template&id=baf4f668&"
import script from "./NewNode.vue?vue&type=script&lang=js&"
export * from "./NewNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports